import action from "i18n/lang/en/action";
import common from "i18n/lang/en/common";
import error from "i18n/lang/en/error";
import invoice from "i18n/lang/en/invoice";
import languages from "i18n/lang/en/languages";
import login from "./login";
import selfcare from "./selfcare";

export const en = {
  action,
  common,
  invoice,
  languages,
  error,
  login,
  selfcare,
} as const;
